import input from './input.js'
import password from './password.js'
import search from './search.js'
import textarea from './textarea.js'
import inputGroup from './input-group.js'
export default { input, password, search, textarea, inputGroup }
